import script from "./limitUserForm.vue?vue&type=script&setup=true&lang=js"
export * from "./limitUserForm.vue?vue&type=script&setup=true&lang=js"

import "./limitUserForm.vue?vue&type=style&index=0&id=1719749e&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1719749e"]])

export default __exports__